import { FC } from 'react';

import { Tooltip } from '@/components';

import { MappingCardProps } from './types';

import styles from './styles.module.scss';

import DoneIcon from '@/assets/icons/done.svg?react';

export const MappingCard: FC<MappingCardProps> = ({ label, description, notMapped, total, handleClick }) => {
  return notMapped !== 0 ? (
    <div className={styles.mappingCardWrapper}>
      <div className={styles.mappingCardTitle}>
        {label} <Tooltip title={description} />
      </div>

      <p className={styles.mappingCardDescription}>
        {notMapped} of {total} codes not mapped
      </p>

      <button className={styles.mappingButton} type="button" onClick={handleClick}>
        Continue
      </button>
    </div>
  ) : (
    <div className={styles.mappedCode}>
      {label}
      <span className={styles.iconWrapper}>
        <DoneIcon color="#52B36B" />
      </span>
    </div>
  );
};
